import { z } from 'zod';

export const brandFormSchema = z.object({
  name: z.string()
    .min(1, 'Nome da marca é obrigatório')
    .min(2, 'Nome da marca deve ter pelo menos 2 caracteres')
    .max(100, 'Nome da marca deve ter no máximo 100 caracteres'),
  areas: z.array(z.string())
    .min(1, 'Selecione pelo menos um setor')
    .max(10, 'Máximo 10 setores permitidos'),
  subsectors: z.array(z.string())
    .max(20, 'Máximo 20 subsetores permitidos'),
  markets: z.array(z.string())
    .min(1, 'Selecione pelo menos um mercado foco')
    .max(15, 'Máximo 15 mercados permitidos'),
  regionalization: z.array(z.string())
    .max(10, 'Máximo 10 regionalizações permitidas'),
  subscription: z.enum(['BASIC', 'MEDIUM', 'ADVANCED', 'PRO'], {
    message: 'Tipo de assinatura é obrigatório',
  }),
  contractStartDate: z.date().optional(),
  is_active: z.boolean(),
  territories: z.array(z.string())
    .min(1, 'Selecione pelo menos um território prioritário')
    .max(20, 'Máximo 20 territórios permitidos'),
  topics: z.array(z.string())
    .min(1, 'Selecione pelo menos um tópico prioritário')
    .max(25, 'Máximo 25 tópicos permitidos'),
  contexts: z.array(z.string())
    .min(1, 'Selecione pelo menos um contexto cultural')
    .max(20, 'Máximo 20 contextos permitidos'),
  platforms: z.array(z.object({
    link: z.string()
      .min(1, 'Link da plataforma é obrigatório')
      .url('Digite uma URL válida'),
    followers: z.string()
      .min(1, 'Número de seguidores é obrigatório')
      .regex(/^\d+$/, 'Digite apenas números para seguidores'),
  }))
    .min(1, 'Adicione pelo menos uma plataforma')
    .max(10, 'Máximo 10 plataformas permitidas'),
  creators: z.array(z.string())
    .max(30, 'Máximo 30 creators permitidos'),
  objectives: z.array(z.string())
    .min(1, 'Selecione pelo menos um objetivo da marca')
    .max(15, 'Máximo 15 objetivos permitidos'),
  
  keywords: z.array(z.string()),
});

export type BrandFormData = z.infer<typeof brandFormSchema>;